module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/5/5-182e3966532f01e833ef892ca4d3c837.jpg";